import { useEffect, useState, useRef } from 'react'
import styled from 'styled-components'
import { ChartGrowthArrows } from 'components/chartGrowthArrows'
// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'
import { TextWidth, ContentWidth } from '@ta-interaktiv/react-disco-grid'
import TextWrap from 'components/TextWrap'
import {
  ChartTitle,
  ChartDescription,
  ChartAnnotations,
  ChartNotes,
  Strong,
  ScrollytellingStepContent,
} from 'components/styles'
import { Trans, useTranslation } from 'react-i18next'

// We cannot rely on the sticky CSS position. It is very shaky on the mobile
// application for some reason and it's bad enough for the user experience to do it manually.
// So we need to calculate the height of the chart and the height of the container, fix the "sticky"
// element with a fixed position and calculate it's top padding to add when we reached the end of the bottom
// of the container.
const StickyTest = () => {
  const [height, setHeight] = useState(0)
  const [step, setStep] = useState(0)
  const t = useTranslation().t

  const handleEnter = (step: any) => {
    if (step.data >= 1 && step.data < 4) {
      setStep(step.data)
    }
  }

  const handleExit = (step: any) => {
    // When we exit the first step in the up direction, we want to unfix the chart and set the step to 0
    if (step.data === 1 && step.direction === 'up') {
      setStep(0)
    }
  }

  return (
    <>
      {/* <TextWidth>
        <ChartAnnotations>
          <ChartTitle>Les plus fortunés polluent toujours plus</ChartTitle>
          <ChartDescription>
            Évolution des émissions suisses de CO₂ par tranche de revenu,{' '}
            <strong>entre 1990 et 2019</strong>, en tonnes par individu.
          </ChartDescription>
        </ChartAnnotations>
      </TextWidth> */}

      <Container margins={-(window.innerHeight - (height ? height : 0)) / 2}>
        <ChartContainer>
          <ChartContent>
            <ContentWidth>
              <ChartGrowthArrows
                handleNewHeight={(h: number) => {
                  setHeight(h)
                }}
                showLastQuintile={step >= 3}
                showAnnotations={(step >= 1 && step) < 4 ? [step] : []}
              />
            </ContentWidth>
          </ChartContent>
        </ChartContainer>

        <ScrollytellingContainer>
          <Scrollama
            offset={0}
            onStepEnter={handleEnter}
            onStepExit={handleExit}
          >
            <Step data={1}>
              <ScrollytellingStep>
                <div />
              </ScrollytellingStep>
            </Step>
            <Step data={2}>
              <ScrollytellingStep>
                {/* <Waypoint topOffset='50%' onEnter={(props) => {handleEnter(1)}} onLeave={handleLeave} /> */}
                <ScrollytellingStepContent opaque small>
                  <Trans
                    i18nKey='chChart:scrollytelling:step1'
                    components={{ strong: <Strong /> }}
                  />
                </ScrollytellingStepContent>
              </ScrollytellingStep>
            </Step>
            <Step data={3}>
              <ScrollytellingStep>
                {/* <Waypoint topOffset='50%' onEnter={(props) => {handleEnter(2)}} onLeave={handleLeave} /> */}
                <ScrollytellingStepContent opaque small>
                  <Trans
                    i18nKey='chChart:scrollytelling:step2'
                    components={{ strong: <Strong /> }}
                  />
                </ScrollytellingStepContent>
              </ScrollytellingStep>
            </Step>
            <Step data={4}>
              <ScrollytellingStep>
                {/* <Waypoint topOffset='50%' onEnter={(props) => {handleEnter(3)}} onLeave={handleLeave} /> */}
                <ScrollytellingStepContent opaque small>
                  <Trans
                    i18nKey='chChart:scrollytelling:step3'
                    components={{ strong: <Strong /> }}
                  />
                </ScrollytellingStepContent>
              </ScrollytellingStep>
            </Step>
          </Scrollama>
        </ScrollytellingContainer>
      </Container>

      <TextWidth>
        <ChartNotes>{t('main:source')}: World Inequality Report</ChartNotes>
      </TextWidth>
    </>
  )
}

const Container = styled.div<{ margins: number }>`
  position: relative;
  margin-top: ${({ margins }) => `${margins}px`};
  margin-bottom: ${({ margins }) => `${margins}px`};
  transform: translateZ(0);
  backface-visibility: hidden;
`

const ChartContainer = styled.div`
  z-index: 1;
  width: 100%;
  top: 0;
  left: 0;
  min-height: 100vh;
  position: sticky;
`

const ChartContent = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
`

const ScrollytellingContainer = styled.div`
  position: relative;
  z-index: 2;
  margin-top: -100vh;
`

const ScrollytellingStep = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`

export default StickyTest
